import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IndecxSurveyService {

  constructor( private readonly http: HttpClient ) { }

  public getParameters(){
    return this.http.get(`/apiconnect/parameters-vt/widget?survey-type=PORTAL_NOVO`);
  }
}
